




























import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import LedgerOverview from '@/components/Accounts/LendingAccounts/Ledgers/LedgerOverview.vue';
import LedgerTransactionsList from '@/components/Accounts/LendingAccounts/Ledgers/Transactions/LedgerTransactionsList.vue';
import LedgerSettings from '@/components/Accounts/LendingAccounts/Ledgers/Settings/LedgerSettings.vue';
import Schedule from '@/models/Accounts/LendingAccounts/Schedules/Schedule';

@Component({ name: 'LedgerSubTabs', components: { LedgerOverview, LedgerTransactionsList, LedgerSettings } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: LendingAccount;

    @Prop({required: true})
    schedule: Schedule;

}
